import intlTelInput from 'intl-tel-input';
import { en, fr, nl, no, es, de } from 'intl-tel-input/i18n';
import { CookieMonster } from 'root/utils/cookies/cookieMonster';
import { getDecodedFormFieldValue } from 'root/utils/dom/localStorage';

const cm = new CookieMonster();

/*
 * Returns an empty string if the phone number is already saved to local storage
 * Otherwise, it tries to get the country code from geoconfig, defaulting to the US
 */
const getInitialCountry = () => {
    return getDecodedFormFieldValue('phone')
        ? ''
        : cm.getCookie('geoConfig')?.country_code?.toLowerCase() ?? 'us';
};

const localizationLibrary: { [key: string]: typeof en } = {
    en,
    fr,
    nl,
    no,
    es,
    de,
};

const getLocalization = () => {
    const langCode = document.querySelector('html')?.getAttribute('lang')?.slice(0, 2);
    if (langCode && localizationLibrary[langCode]) return localizationLibrary[langCode];
    return en;
};

const initPhoneLib = (form: HTMLElement) => {
    const phoneField = form.querySelector<HTMLInputElement>(
        '[data-form-field-name=phone]'
    );
    return [
        phoneField
            ? intlTelInput(phoneField, {
                  // @ts-ignore
                  loadUtils: () => import('intl-tel-input/utils'),
                  i18n: getLocalization(),
                  allowDropdown: true,
                  fixDropdownWidth: false,
                  separateDialCode: true,
                  initialCountry: getInitialCountry(),
              })
            : null,
        phoneField,
    ];
};
export { initPhoneLib };
